import React from 'react';
import styled, { keyframes } from 'styled-components';

const CharactersSkeleton = () => {
  return (
    <Root>
      {[...Array(8)].map((_, index) => (
        <SkeletonCard key={index}>
          <CardContent>
            <SkeletonTitle />
            <SkeletonText />
            <SkeletonText style={{ width: '80%' }} />
          </CardContent>
        </SkeletonCard>
      ))}
    </Root>
  );
};

export default CharactersSkeleton;

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const Root = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 308px);
  gap: 16px;
  justify-content: center;
  padding: 20px;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;

  @media (max-width: 1330px) {
    grid-template-columns: repeat(3, minmax(280px, 308px));
    padding: 16px;
    gap: 12px;
  }

  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, minmax(280px, 308px));
    padding: 12px;
  }

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
    padding: 12px;
    gap: 12px;
  }
`;

const SkeletonCard = styled.div`
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  height: 396px;
  width: 100%;
  background: linear-gradient(90deg, rgba(169, 169, 169, 0.00) 0%, rgba(169, 169, 169, 0.50) 52.14%, rgba(169, 169, 169, 0.00) 100%), #696969;
  background-size: 2000px 100%;
  animation: ${shimmer} 2s linear infinite;

  @media (max-width: 768px) {
    height: 440px;
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    background: linear-gradient(180deg, rgba(29, 29, 29, 0.00) 50%, rgba(29, 29, 29, 0.85) 80%, rgba(16, 13, 11, 1) 100%);
    pointer-events: none;
  }
`;

const CardContent = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 32px 16px 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 1;

  @media (max-width: 700px) {
    padding: 24px 12px 16px 12px;
  }
`;

const SkeletonTitle = styled.div`
  width: 96px;
  height: 22px;
  border-radius: 4px;
  background: linear-gradient(90deg, rgba(169, 169, 169, 0.15) 0%, rgba(169, 169, 169, 0.45) 52.14%, rgba(169, 169, 169, 0.15) 100%), rgba(169, 169, 169, 0.2);
  background-size: 2000px 100%;
  animation: ${shimmer} 2s linear infinite;
`;

const SkeletonText = styled.div`
  width: 100%;
  height: 16px;
  border-radius: 4px;
  background: linear-gradient(90deg, rgba(169, 169, 169, 0.15) 0%, rgba(169, 169, 169, 0.45) 52.14%, rgba(169, 169, 169, 0.15) 100%), rgba(169, 169, 169, 0.2);
  background-size: 2000px 100%;
  animation: ${shimmer} 2s linear infinite;
`; 